// extracted by mini-css-extract-plugin
export default {"button":"ButtonDelete_button__ET5vA","buttonIcon":"ButtonDelete_buttonIcon__vmuzk"};